import { Approver as ApproverDto } from "src/app/proxy/approvers";

export class Approver {
  id: number;
  isForContractor: boolean;
  locationId: number;
  userName: string;
  name: string;

  constructor(dto: ApproverDto) {
    Object.assign(this, dto);
  }
}